import React from 'react'
import BaseComponent from './BaseContainer'
import { Query } from 'react-apollo'
import Articles from '../components/list/Articles'
import getArticles from '../apollo/graphql/article/getArticles'
import { Loader, Message, Dimmer } from 'semantic-ui-react'

class ArticlesContainer extends BaseComponent {
  render() {
    return (
      <Query query={getArticles} fetchPolicy='network-only'>
        {({ data, client, error, loading }) => {
          if (loading) {
            return (
              <Dimmer active inverted>
                <Loader inverted>Chargement</Loader>
              </Dimmer>
            )
          }
          if (error) {
            return (
              <Message negative>
                <Message.Header>Erreur</Message.Header>
                <p>{error.message}</p>
              </Message>
            )
          }
          return (
            <Articles articles={data.getArticles} />
          )
        }}
      </Query>
    )
  }
}

export default ArticlesContainer



// WEBPACK FOOTER //
// ./src/containers/ArticlesContainer.js